module.exports = __webpack_public_path__ + "static/media/4. Jeera Cookies 300 g.764a7381.jpg";